<template>
  <div class="app">
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile/>
      <b-link class="navbar-brand" to="#">
        <img
            class="navbar-brand-full"
            src="img/brand/logo.png"
            width="50"
            height="40"
            alt="http://ktru.mf.uz/"
        />
        <img
            class="navbar-brand-minimized"
            src="img/brand/logo.png"
            width="30"
            height="30"
            alt="http://ktru.mf.uz/"
        />
      </b-link>
      <SidebarToggler class="d-md-down-none" display="lg"/>
        <b-nav-item class="notification">
          <a v-if="newMessage" class="btn btn-danger ml-3 white blink_me" @click="gotoVerification">Есть неподтвержденное действие </a>
        </b-nav-item>
      <b-navbar-nav class="d-md-down-none ml-auto">
        <b-nav-item class="d-md-down-none">
          <a v-on:click="logOut()">Выход</a>
        </b-nav-item>
      </b-navbar-nav>
      <AsideToggler class="d-none d-lg-block"/>
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader/>
        <SidebarForm/>
        <SidebarNav :navItems="navItems"></SidebarNav>
        <SidebarFooter/>
        <SidebarMinimizer/>
      </AppSidebar>
      <main class="main">
        <div class="load" v-if="$store.state.isLoading"></div>
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
      <AppAside fixed>
        <!--aside-->
        <DefaultAside/>
      </AppAside>
    </div>
  </div>
</template>

<script>
import {funcs} from '@/_helpers/_sumple_funcs';
import nav from "@/_helpers/_nav";
import { GET } from "../shared/api";
import {
  Header as AppHeader,
  SidebarToggler,
  Sidebar as AppSidebar,
  SidebarFooter,
  SidebarForm,
  SidebarHeader,
  SidebarMinimizer,
  SidebarNav,
  Aside as AppAside,
  AsideToggler,
  Footer as TheFooter
} from "@coreui/vue";
import DefaultAside from "./DefaultAside";
import {Role} from "@/_helpers/roles";

export default {
  name: "DefaultContainer",
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    DefaultAside,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer
  },
  data() {
    return {
      navItems: [],
      newMessage: false
    };
  },
  methods: {
    logOut() {
      localStorage.clear();
      this.$router.push({name: "Login"});
    },
    calculateNavItems() {
      let user = JSON.parse(localStorage.getItem("user"));
      let roles = typeof user.roles !== 'undefined' ? user.roles : [];
      if(user.roles && user.roles.length > 0 && user.roles.includes(Role.combination_user)){
        // nav.items.forEach((navEl) => {
        //   if (navEl.role === Role.combination_user || navEl.url.includes('translations') || navEl.url.includes('tree')) this.navItems.push(navEl)
        // });
        nav.items.forEach((navEl) => {
          if (navEl.role === Role.combination_user ) this.navItems.push(navEl)
        });
      }else{
        nav.items.forEach((navEl) => {
          if (typeof navEl.role === 'undefined') this.navItems.push(navEl);
          else if(funcs.inArray(navEl.role,roles)) this.navItems.push(navEl);
        });
      }
    },
    checkVerification: function (){
        var app = this;
        setInterval(function () {
          // GET([], "/v1/verification/exist", app, false, false).then(response => {
          //   app.$set(app, 'newMessage', response);
          // });
        }, 1000*4*1);
    },
    gotoVerification(){
      this.$router.push({name: 'verification'});
    },
    gotoCombination(){
      this.$router.push({name: 'combination-v2'});
    }

  },
  computed: {
    name() {
      return this.$route.name;
    },
    list() {
      return this.$route.matched.filter(
          route => route.name || route.meta.label
      );
    }
  },
  watch: {
    $route(to, from) {
      let user = JSON.parse(localStorage.getItem("user"));
      if (
        user &&
        Array.isArray(user.roles) &&
        user.roles.includes(Role.combination_user) &&
        to.name !== 'combination-v2'
      ) {
        this.gotoCombination();
      }
    }
  },
  mounted() {
    this.calculateNavItems();
    let user = JSON.parse(localStorage.getItem("user"));
    if(user.roles && user.roles.length > 0 && user.roles.includes(Role.combination_user) && !this.$route.name.includes('combination-v2')) {
      // if(!this.$route.name.includes('tree') && !this.$route.name.includes('translations')){
      //   this.gotoCombination()
      // }
      this.gotoCombination()
    }
    if(Array.isArray(user.roles) && user.roles.includes('administrator'))
      this.checkVerification();
  }
};
</script>

<style>
.blink_me {
  animation: blinker 1s linear infinite;
  animation-timing-function: ease;
  animation-duration: 2s;
  animation-delay: 5s;
}
.notification{
  list-style: none;
}

@keyframes blinker {
  50% {
    opacity: 0;
  }
}
</style>
